// src/plugins/fontawesome.js

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// 按需导入图标
import {
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowTrendDown,
  faArrowTrendUp,
  faArrowUp,
  faArrowsRotate,
  faCalendar,
  faCalendarAlt,
  faChartBar,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faCircleExclamation,
  faClock,
  faDatabase,
  faDownload,
  faEdit,
  faExclamationTriangle,
  faEye,
  faFile,
  faFileAlt,
  faFilePdf,
  faHeadphones,
  faInbox,
  faInfo,
  faInfoCircle,
  faLock,
  faMinus,
  faMoneyBill,
  faMusic,
  faPause,
  faPlay,
  faPlus,
  faQuestionCircle,
  faSearch,
  faSearchPlus,
  faSpinner,
  faStar,
  faTrash,
  faTrophy,
  faUpload,
  faUser,
  faUserCheck,
  faUsers,
  faUsersSlash,
  faVideo,
  faWarning,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'

// 将图标添加到库中
library.add(
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowTrendDown,
  faArrowTrendUp,
  faArrowUp,
  faArrowsRotate,
  faCalendar,
  faCalendarAlt,
  faChartBar,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faCircleExclamation,
  faClock,
  faDatabase,
  faDownload,
  faEdit,
  faExclamationTriangle,
  faEye,
  faFile,
  faFileAlt,
  faFilePdf,
  faHeadphones,
  faInbox,
  faInfo,
  faInfoCircle,
  faLock,
  faMinus,
  faMoneyBill,
  faMusic,
  faPause,
  faPlay,
  faPlus,
  faQuestionCircle,
  faSearch,
  faSearchPlus,
  faSpinner,
  faStar,
  faTrash,
  faTrophy,
  faUpload,
  faUser,
  faUserCheck,
  faUsers,
  faUsersSlash,
  faVideo,
  faWarning,
  faXmark,
)

export function setupFontAwesome(app) {
  app.component('font-awesome', FontAwesomeIcon)
  app.component('font-awesome-icon', FontAwesomeIcon)
}
